<template>
  <div @contextmenu="tabRight"
       @touchstart="touchstarts()"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <div class="flow-arch">
      <tit :title="blockData.title"
           :subtitle="blockData.subtitle"
           :src='rightSrc'
           @clear="clearSrc"
           @refesh="refeshData"
           :flowType="blockData.floorType"></tit>
      <div class="outreach_content clearfix">
        <div v-if="!rightSrc"
             class="right-content"
             ref="centerEle">
          <!-- 左右多图文 -->
          <expert v-if="centerStyle=='expertsAlliance'"
                  @emitHandleDetail="handleDetail"
                  @emitContextMenuItem="leftRightMove"
                  :class="[centerStyle,'smartAppSameScreenShow']"
                  :tagsDataList="listData" />
          <!-- 多图展示 -->
          <enterpris v-else-if="centerStyle=='enterprisAlliance'"
                     @emitHandleDetail="handleDetail"
                     @emitContextMenuItem="leftRightMove"
                     :class="[centerStyle,'smartAppSameScreenShow']"
                     :tagsDataList="listData" />
          <!-- 信息列表 -->
          <news v-else-if="centerStyle=='article'"
                @emitHandleDetail="handleDetail"
                @emitContextMenuItem="leftRightMove"
                :class="[centerStyle,'smartAppSameScreenShow']"
                :tagsDataList="listData" />
          <!-- 同屏展示 -->
          <baseGroup v-else-if="centerStyle=='smartAppSameScreenShow'"
                     @emitHandleDetail="handleDetail"
                     @emitContextMenuItem="leftRightMove"
                     :centerStyle="centerStyle"
                     :preNum="preNum"
                     :swiperInd="swiperInd"
                     :standList="standardListJson" />
          <!-- 多图遮罩/标准楼层 -->
          <smartApp v-else-if="centerStyle=='smartApp'||centers == 'banner'"
                    :centerStyle='centerStyle'
                    :blockData='blockData'
                    :blockCenterList='blockCenterList'
                    :tabActiveType="tabActiveType"
                    @emitHandleDetail="handleDetail"
                    :tabLeftRightLen="tabLeftRightLen"
                    :listData="listData"
                    @emitContextMenuItem="leftRightMove"
                    ref='smartApp'
                    @emitChangeFlowTab='changeFlowTab'
                    :flowStep='flowStep'
                    :swiperInd='swiperInd' />
          <!-- 图文信息 -->
          <tradeNews v-else-if="centerStyle=='tradeNews'"
                     :centerStyle='centerStyle'
                     :blockCenterList='blockCenterList'
                     :blockData='blockData'
                     :listData="listData" />
          <!-- 多图文列表 -->
          <knowledgeCenter v-else-if="centerStyle=='knowledgeCenter'"
                           :centerStyle='centerStyle'
                           :blockData='blockData'
                           @emitHandleDetail="handleDetail"
                           @emitContextMenuItem="leftRightMove"
                           :listData="listData"
                           :tabLeftRightLen="tabLeftRightLen" />
          <!-- 流程架构 -->
          <baseGroupProcess v-else-if="centerStyle=='flowArchShow'"
                            :class="['flowArchShow']"
                            :style="{height:`${baseNavHeight-66}px`}"
                            :centerStyle="centerStyle"
                            :preNum="preNum"
                            :swiperInd="swiperInd"
                            :standList="standardListJson"
                            @emitHandleDetail="handleDetail"
                            @emitContextMenuItem="leftRightMove" />
          <!-- 单图文展示/企业简介 -->
          <qyjjContent v-else-if="centerStyle=='companyIntroduce'"
                       :blockData='blockData' />
          <!-- 线型图 -->
          <smartChart v-else-if="centerStyle=='smartChart'"
                      :blockData='blockData'
                      ref='_changeFlowTab' />
          <!-- 横向列表区块 -->
          <horizontal v-else-if="centerStyle=='leftRightImgText'"
                      @emitHandleDetail="handleDetail"
                      @emitContextMenuItem="leftRightMove"
                      :listData='listData' />
          <!-- 小区块 -->
          <smallBlock v-else-if="centerStyle=='pictureImgText'"
                      @emitHandleDetail="handleDetail"
                      @emitContextMenuItem="leftRightMove"
                      :listData='listData' />
        </div>
        <!-- 右键链接展示开始 -->
        <div v-if="rightSrc">
          <!--切换一开始-->
          <iframe :style="{width:'100%',height:`${height}px`}"
                  :src="rightSrc"
                  frameborder="0"></iframe>
          <!--切换一结束-->
        </div>
        <!-- 右键链接展示结束 -->
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../bus.js'
import tit from "./control/tit.vue"
import topTab from "./control/topTab.vue"
import bottomTab from "./control/bottomTab.vue"
import leftTab from "./control/leftTab.vue"
import rightTab from "./control/rightTab.vue"
import expert from "./expert.vue"
import enterpris from "./enterpris.vue"
import news from "./news.vue"
import knowledgeCenter from "./knowledgeCenter.vue"
import baseGroup from "./baseGroup.vue"
import baseGroupProcess from "./baseGroupProcess.vue"
import ZImage from "../ZImage.vue"
import smartApp from "./smartApp.vue"
import tradeNews from "./tradeNews.vue"
import qyjjContent from "./qyjjContent.vue"
import smartChart from "./smartChart.vue"
import horizontal from "./horizontal_list.vue"
import smallBlock from "./small_block.vue"
export default {
  name: 'flowArchShow',
  components: {
    tit: tit,
    topTab,
    bottomTab,
    leftTab,
    rightTab,
    expert,
    enterpris,
    ZImage,
    news,
    knowledgeCenter,
    baseGroup,
    baseGroupProcess,
    smartApp,
    tradeNews,
    qyjjContent,
    smartChart,
    horizontal,
    smallBlock
  },
  props: {
    blockData: {
      type: Object
    },
    baseNavHeight: {
      type: Number
    },
    _centerStyle: {
      require: true,
      default: "flowArchShow"
    },
  },
  data () {
    return {
      timeOutEvent: 0,
      rightSrc: '',
      height: '',
      heights: '',
      swiperInd: 'dhsakjdandkak',
      preNum: 5,
      leftTabInd: 0,
      topTabInd: 0,
      contendId: '',
      floorDetailShow: '',
      listData: [],
      standardListJson: [],
      contentId: '',
      nodeId: '',
      blockId: '',
      flowId: '',
      centerStyle: '',
      tabLeftRightLen: 7,
      centers: '',
      blockCenterList: [],
      tabActiveType: 'center'
    }
  },
  watch: {
    "$store.state.rightSrc": function (val) {
      if (!this.rightSrc) {
        this.rightSrc = this.blockData.id == window.$floorflowId ? val : '';
        this.height = this.heights;
      }
    }
  },
  mounted () {
    this.nodeId = this.blockData.nodeId;
    this.flowId = this.blockData.id;
    this.swiperInd = this.blockData.id;

    this.$http
      .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
        // appId: this.blockData.appId,
        appId: this.getQuery('appId'),
        flowId: this.blockData.id,
        flowOrDetail: 'detail',
        domainNameType: document.location.pathname.split('/')[1]
      }).then(res => {
        this.floorDetailShow = res.data ? res.data : 'down'
      });
    this.centerStyle = this._centerStyle;
    this.getBlockByFlowId(this.blockData.id);
    var _this = this;
    var elementResizeDetectorMaker = require("element-resize-detector")
    var erd = elementResizeDetectorMaker();
    //监听中心展示高度
    erd.listenTo(this.$refs.centerEle, function (element) {
      _this.heights = element.clientHeight;
    })
  },
  computed: {
    tagData () {
      return this.$store.state.tagData;
    }
  },
  methods: {
    touchstarts () {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.tabRight();
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //关闭中心iframe
    clearSrc () {
      this.rightSrc = '';
    },
    changeFlowTab () {
      console.log("a");
    },
    tabRight () {
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$floorflowId = '';
      window.$nodeId = '';
      if (this.nodeId) {
        window.$nodeId = this.nodeId;
      }

      window.$floorflowId = this.blockData;
      window.$floorId = this.flowId;
      if (this.contentId) {
        if (!window.$rightLeft) {
          window.$rightLeft = {}
        }
        window.$rightLeft.center = {
          //     contentId:this.contentId,
          //     contentShowRowsSort:'0'
        }
      }
      window.$blockId = this.blockId;
    },
    setDefaultTags () {
      let _this = this;
      for (var i = 0; i < 10; i++) {
        _this.listData.push({
          id: '',
          pictures: [require('../../assets/image/images/default_media.png')],
          others: [{ standardData: '标签' }, { standardData: '描述' }],
          tags: [{ standardName: '', standardData: '' }]
        })
      }
    },
    getProduct (pDataArr = []) {
      const _this = this;
      if (pDataArr.length == 0) {
        _this.setDefaultTags();
      } else {
        pDataArr.forEach((pData) => {
          var tags = [];
          var pictures = [];
          var others = [];
          var btns = [];
          if (!pData || !pData.standardJson) {
            _this.setDefaultTags();
            return false;
          } else {
            pData.standardJson.forEach((ele) => {
              // if(ele.isShow!='0'){
              if (ele.standardType == 0 && ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                pictures.push(ele.standardData);
              } else if (ele.standardType == 0) {
                others.push(ele);
              } else if (ele.standardType == 3) {
                btns.push(ele);
              }

              // }
              if (ele.isShow == 1 && ele.standardType != 3) {
                tags.push(ele);
              }
            });
            this.showList = this.showList == false ? true : true;
          }
          _this.flowStep = 4;
          _this.contentId = pData.contentId;
          _this.listData.push({
            contentShowRowsSort: pData.contentShowRowsSort,
            sceneId: pData.sceneId,
            contentId: pData.contentId,
            sceneGroupId: pData.sceneGroupId,
            pictures: pictures.splice(0, 4),
            others: others.splice(0, 5),
            btns: btns.splice(0, 2),
            tags: tags.splice(0, 9)
          })
        })
      }

    },
    getBlockByFlowId (id) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getBlockDataListByFlowPid.json", {
          // appId: this.blockData.appId,
          appId: this.getQuery('appId'),
          flowId: id
        })
        .then(res => {
          if (res.state == 1) {
            this.blockId = res.data[0].id;
            var Blockitem = res.data[0];
            return Blockitem;
          }
        }).then(Blockitem => {
          if (Blockitem) {
            this.getTagsByBlockId(Blockitem);
          }
        });
    },
    getBlockTagsArr (pDataArr = []) {
      var listData = [];
      if (pDataArr.length == 0) {
        return listData;
      }
      pDataArr.forEach((pData) => {
        var tags = [];
        var pictures = [];
        var others = [];
        var btns = [];
        if (!pData || !pData.standardJson) {
          return false;
        } else {
          pData.standardJson.forEach((ele) => {
            if (ele.standardType == 0 && ele.standardData && (ele.standardData.indexOf('.flv') > 0 || ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
              pictures.push(ele.standardData);
            } else if (ele.standardType == 0) {
              others.push(ele);
            } else if (ele.standardType == 3) {
              btns.push(ele);
            }

            if (ele.isShow == 1 && ele.standardType != 3) {
              tags.push(ele);
            }
          });
        }
        //标签数据构造
        listData.push({
          id: pData.contentId,
          flowType: "tagsData",
          name: others.length && others[0].standardData ? others[0].standardData : '',
          contentShowRowsSort: pData.contentShowRowsSort,
          sceneId: pData.sceneId,
          contentId: pData.contentId,
          sceneGroupId: pData.sceneGroupId,
          pictures: pictures.splice(0, 2),
          others: others.splice(0, 5),
          btns: btns.splice(0, 2),
          tags: tags.splice(0, 9)
        })
      })
      return listData;
    },
    getTagsByBlockId (item) {
      this.blockId = item.id;
      this.nodeId = item.nodeId;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json", {
          // appId: this.blockData.appId,
          appId: this.getQuery('appId'),
          sceneId: item.sceneId,
          blockId: item.id,
          nodeId: item.nodeId,
          sceneGroupId: item.sceneGroupId,
        }).then(res => {
          if (this.centerStyle == 'banner') {
            this.centers = 'banner';
          }
          if (res.state == 1) {
            this.centerStyle = res.data[0].floorStyle;
            this.getProduct(res.data);
            this.standardListJson = res.data;
            var tagsArr = this.getBlockTagsArr(res.data);
            this.blockCenterList = tagsArr;
          } else {
            this.getProduct();
          }
        })
    },
    handleDetail (ite) {
      window.$nodeId = this.nodeId;
      var blockId = this.blockId;
      var contentId = ite.contentId ? ite.contentId : this.contentId;
      sessionStorage.setItem('floorDetailShow', this.floorDetailShow);
      sessionStorage.setItem('originName', JSON.stringify({ blockId: blockId, contentId: contentId }));
      this.$blockGetData.handleDetail(this, ite);
    },
    leftRightMove (ind, ev) {
      this.$store.commit('setFlowType', this.blockData.floorType);
      const item = this.standardListJson[ind];
      window.$nodeId = item.nodeId;
      Bus.$emit('windowRight', ev, item);
      var left = {}, center = {}, right = {};
      if (ind > 0) {
        var leftItem = this.standardListJson[ind - 1];
        if (leftItem && leftItem.contentId) {
          left = {
            blockId: leftItem.blockId,
            contentId: leftItem.contentId,
            contentShowRowsSort: leftItem.contentShowRowsSort
          };
        }
      }
      if (ind < this.standardListJson.length) {
        var rightItem = this.standardListJson[ind + 1];
        if (rightItem && rightItem.contentId) {
          right = {
            blockId: rightItem.blockId,
            contentId: rightItem.contentId,
            contentShowRowsSort: rightItem.contentShowRowsSort
          };
        }
      }
      if (item && item.contentId) {
        center = {
          item: item,
          blockId: item.blockId,
          contentId: item.contentId,
          contentShowRowsSort: ind,
          standardJson: item.standardJson
        }
      }

      var rightLeft = {
        left: left,
        center: center,
        right: right
      }

      Bus.$emit('sendCircleType', { circle: this.canAddCircleData, dliverProp: this.candliverProp });
      window.$rightLeft = rightLeft;
    },
    isVideo (t) {
      var ty = false;
      if (t) {
        if (t.indexOf('.flv') > 0) {
          ty = true
        }
        if (t.indexOf('.mp4') > 0) {
          ty = true
        }
      }
      return ty;
    },
    //刷新数据
    refeshData () {
      this.getBlockByFlowId(this.blockData.id);
      this.rightSrc = ''
    }
  }
}
</script>
<style scoped lang="scss">
.right-content {
  .bottom-switch {
    padding: 18px 20px;
    .bottom-content {
      height: 100%;
      overflow: hidden;
      .arrow-left {
        z-index: 9;
        display: none;
        width: 22px;
        height: 48px;
        position: absolute;
        top: 50%;
        margin-top: -24px;
        left: 0;
        background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
          no-repeat center;
        cursor: pointer;
      }
      .arrow-right {
        z-index: 9;
        display: none;
        width: 22px;
        height: 48px;
        position: absolute;
        top: 50%;
        margin-top: -24px;
        right: 0;
        background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
          no-repeat center;
        cursor: pointer;
      }
      &:hover {
        .arrow-left {
          display: block;
        }
        .arrow-right {
          display: block;
        }
      }
      ul {
        li {
          display: block;
          font-size: 0;
          margin-right: 18px !important;
          width: 217px;
          height: 100%;
          line-height: 108px;
          background: #fafafa;
          border: 1px solid#ddd;
          position: relative;
          > a {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .li_hover {
              transition: all 0.2s linear;
              width: calc(100% - 20px);
              // height: 100%;
              position: absolute;
              left: 0;
              bottom: 0px;
              background: rgba(0, 0, 0, 0.6);
              padding: 0 10px;
              // &:hover {
              //     bottom: 0px;
              // }
              .li_hover_title {
                width: calc(100% - 20px);
                margin: 0;
                font-size: 16px;
                color: #fff;
                height: 40px;
                line-height: 40px;
                // border-bottom: 1px dashed #bbbbbb;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: center;
                font-weight: 700;
              }
              .img_right {
                color: #ffffff;
                border: 1px solid #ffffff;
                text-align: center;
                line-height: 18px;
                vertical-align: middle;
                border-radius: 50%;
                height: 18px;
                width: 18px;
                position: absolute;
                top: 10px;
                right: 10px;
                &::after {
                  position: absolute;
                  content: "";
                  border-right: 1px solid #ffffff;
                  border-top: 1px solid #ffffff;
                  transform: rotate(45deg);
                  height: 6px;
                  width: 6px;
                  top: 5px;
                  left: 5px;
                }
              }
              .li_hover_conter {
                border-top: 1px dashed #bbbbbb;
                display: none;
                text-align: left;
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
                color: #fff;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 7;
                height: calc(100% - 59px);
                width: 198px;
                overflow: auto;
                .label-box {
                  width: 100%;
                }
                .label-set {
                  height: 26px;
                  line-height: 26px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
              &:hover {
                transition: all 0.2s linear;
                height: 100%;
                .li_hover_conter {
                  display: block;
                }
              }
            }
          }
        }
      }
      // 树形菜单
      .watch {
        width: 100%;
        max-height: 100%;
        overflow: hidden;
        line-height: 32px;
        .version {
          font-size: 14px;
          width: 100%;
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .multistage-left {
          padding-right: 18px;
          width: 282px;
          height: 324px;
          overflow: auto;
        }
        .blue-right {
          padding-left: 18px;
          width: 228px;
          height: 324px;
          overflow: auto;
        }
        .blue-right .version a:hover {
          background-color: #fafafa;
        }
        .blue-right a {
          color: #2f8eed;
          display: block;
          height: 32px;
          width: 100%;
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .black-center {
          padding: 0 16px;
          border-left: 1px dashed #ddd;
          border-right: 1px dashed #ddd;
          width: calc(100% - 580px);
          height: 324px;
          overflow: auto;
        }
      }
      .no-data {
        color: #999999;
        font-size: 16px;
        text-align: center;
        margin-top: 20px;
      }
      .no-data.white {
        color: #fff;
        font-size: 12px;
        text-align: left;
        margin-top: 0px;
      }
    }
    //企业简介样式
    &.companyIntroduce {
      .bottom-content {
        overflow: hidden auto;
        ul {
          li {
            border: none;
            > a {
              position: relative;
              clear: both;
              width: 100%;
              img {
                float: left;
                width: 50%;
              }
              video {
                float: left;
                width: 50%;
              }
              .z-image {
                float: left;
                width: 50%;
              }
              .linear-gradient {
                float: left;
                width: 50%;
              }
              .li_hover {
                width: calc(50% - 40px);
                background: #fff;
                float: left;
                position: static;
                padding: 0 20px;
                .li_hover_title {
                  color: #333333;
                }
                .li_hover_conter {
                  color: #333333;
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
    &.banner {
      .bottom-content {
        ul {
          li {
            border: none;
            > a {
              .li_hover {
                display: none;
              }
            }
          }
        }
      }
    }
  }
}

.flow-arch .right-content .bottom-switch .bottom-content ul li {
  height: 260px;
}
.flow-arch .right-content .bottom-switch .bottom-content ul li > a .li_hover {
  bottom: -222px;
}
.flowArchShow
  .right-content
  .bottom-switch
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: 0px;
}
.flow-arch
  .right-content
  .bottom-switch.flowArchShow
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: 0px;
}
.live-main .right-content .bottom-switch.lives-type {
  height: 254px;
}
.live-main .right-content .bottom-switch.lives-type .bottom-content ul li {
  height: 254px;
}
.live-main
  .right-content
  .bottom-switch.lives-type
  .bottom-content
  ul
  li
  > a
  .li_hover {
  bottom: -214px;
}
.live-main
  .right-content
  .bottom-switch.lives-type
  .bottom-content
  ul
  li
  > a
  .li_hover:hover {
  bottom: 0px;
}
</style>
    <style lang="scss" scoped>
.bottom-content ul li {
  background-color: #fff !important;
  border: none !important;
}
.right-content .bottom-switch.flowArchShow {
  padding: 0px;
}
.right-content
  .bottom-switch.flowArchShow
  .bottom-content
  ul
  li
  > a
  .li_hover
  .li_hover_conter {
  height: 188px;
}
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/flowArchShow.vue